import { useCallback, useState } from "react";
import { EventType } from "src/store/api/generatedApi";

export type PendingAreaSelection = Readonly<{
  eventId: string;
  eventType: EventType;
  openedOnKeyRelease: boolean;
}>;

export const usePendingAreaSelection = () => {
  const [pendingAreaSelection, setPendingAreaSelection] =
    useState<PendingAreaSelection | null>(null);

  const clearPendingAreaSelection = useCallback(() => {
    setPendingAreaSelection(null);
  }, []);

  return {
    pendingAreaSelection,
    setPendingAreaSelection,
    clearPendingAreaSelection,
  };
};
